import Icon from "components/Icon";
import NewTable, { TableBodyData, TableHeaderColumn } from "components/NewTable";
import PageDefault from "components/PageDefault";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import profileService from "services/profile.service";;

export default function Profile(){
  const history = useHistory();
  const { t } = useTranslation()

  return (
    <PageDefault title={t('title:profiles')}>
      <PageDefault.Title>{t('title:profiles')}</PageDefault.Title>
      <PageDefault.Content>
        <Row className="mt-3 mb-3">
          <Col>
            <Link to="/admin/profile/create">
              <Button>{t('button:add_profile')}</Button>
            </Link>
          </Col>
        </Row>
        <NewTable>
          <TableHeaderColumn dataField="id" bodyNowrap>ID</TableHeaderColumn>
          <TableHeaderColumn dataField="name" bodyNowrap >Nome</TableHeaderColumn>
          <TableHeaderColumn dataField="type.name" bodyNowrap>Tipo</TableHeaderColumn>
          <TableHeaderColumn dataField="id|" mask={(v:any[])=>{
            const [id] = v;
            return (
              <>
                <Button size="sm" style={{margin:"0px 1px"}} onClick={()=>{history.push(`profile/edit/${id}`);}}><Icon name="edit"/></Button>
                <Button size="sm" style={{margin:"0px 1px"}} onClick={()=>{history.push(`profile/show/${id}`);}}><Icon name="eye"/></Button>
              </>
            );
          }}>Ação</TableHeaderColumn>
          <TableBodyData 
            request={profileService} 
            filterDefaut={{
              fields:"id,name,profile_type_id",
              embed:"type:id,name"
            }}
          />
        </NewTable>
      </PageDefault.Content>
    </PageDefault>
  );
}